import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useState } from 'react';
import { Dimensions, ScrollView, Text, View } from 'react-native';
import { RadioGroup } from '../../Radio/rn/RadioGroup';
import { Popup } from '../../Popup/rn';
import { Button } from '../../Button/rn';
import { Modal } from '../../Modal/rn/Modal';
import styles from './styles';
import { CheckboxGroup } from '../../Radio/rn/CheckboxGroup';
import { safe_area_insets_bottom } from '../../../styles/rn';
var screenHeight = Dimensions.get('window').height;
var POPUP_TITLE_HEIGHT = 48;
var BUTTON_AREA_HEIGHT = 60;
export var PopupOption = function PopupOption(props) {
  var _modalProps$footer, _modalProps$footer$bu, _radioGroupProps$opti, _ref, _ref2;
  var popupProps = props.popupProps,
    radioGroupProps = props.radioGroupProps,
    multiRadioGroupProps = props.multiRadioGroupProps,
    multiCheckboxGroupProps = props.multiCheckboxGroupProps,
    footerProps = props.footerProps,
    showConfirm = props.showConfirm,
    modalProps = props.modalProps,
    customerElement = props.customerElement,
    endText = props.endText;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalActive = _useState2[0],
    setModalActive = _useState2[1];
  var scrollViewHeight = screenHeight * 0.8 - POPUP_TITLE_HEIGHT - BUTTON_AREA_HEIGHT - safe_area_insets_bottom;
  var onFooterClick = function onFooterClick() {
    var _footerProps$onClick;
    footerProps === null || footerProps === void 0 ? void 0 : (_footerProps$onClick = footerProps.onClick) === null || _footerProps$onClick === void 0 ? void 0 : _footerProps$onClick.call(footerProps);
    if (showConfirm) {
      setTimeout(function () {
        setModalActive(true);
      }, 50); // DESC: 0 也生效，不加延迟会导致 popup 不消失
    }
  };

  var onModalClose = function onModalClose() {
    setModalActive(false);
    popupProps === null || popupProps === void 0 ? void 0 : popupProps.onClose();
  };
  var modalFooter = modalProps !== null && modalProps !== void 0 && modalProps.footer ? _objectSpread(_objectSpread({}, modalProps === null || modalProps === void 0 ? void 0 : modalProps.footer), {}, {
    buttons: modalProps === null || modalProps === void 0 ? void 0 : (_modalProps$footer = modalProps.footer) === null || _modalProps$footer === void 0 ? void 0 : (_modalProps$footer$bu = _modalProps$footer.buttons) === null || _modalProps$footer$bu === void 0 ? void 0 : _modalProps$footer$bu.map(function (btn) {
      return _objectSpread(_objectSpread({}, btn), {}, {
        onClick: function onClick() {
          var _btn$onClick;
          btn === null || btn === void 0 ? void 0 : (_btn$onClick = btn.onClick) === null || _btn$onClick === void 0 ? void 0 : _btn$onClick.call(btn);
          setModalActive(false);
          popupProps === null || popupProps === void 0 ? void 0 : popupProps.onClose();
        }
      });
    })
  }) : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popup, _extends({}, popupProps, {
    showCloseIcon: true,
    contentStyle: [{
      padding: 0
    }, popupProps === null || popupProps === void 0 ? void 0 : popupProps.contentStyle],
    titleStyle: [_objectSpread({}, styles['popup-option-title']), popupProps === null || popupProps === void 0 ? void 0 : popupProps.titleStyle]
  }), customerElement ? customerElement : /*#__PURE__*/React.createElement(View, null, radioGroupProps && ((_radioGroupProps$opti = radioGroupProps.options) === null || _radioGroupProps$opti === void 0 ? void 0 : _radioGroupProps$opti.length) > 0 && /*#__PURE__*/React.createElement(ScrollView, {
    style: {
      maxHeight: scrollViewHeight
    }
  }, radioGroupProps && /*#__PURE__*/React.createElement(RadioGroup, _extends({}, radioGroupProps, {
    options: radioGroupProps.options ? radioGroupProps.options.map(function (opt) {
      return _objectSpread(_objectSpread({}, opt), {}, {
        textStyle: _objectSpread({
          lineHeight: undefined
        }, opt.textStyle),
        containerStyle: _objectSpread(_objectSpread({}, styles['popup-option-radio']), opt.containerStyle)
      });
    }) : []
  }))), ((_ref = multiRadioGroupProps || []) === null || _ref === void 0 ? void 0 : _ref.length) > 0 && /*#__PURE__*/React.createElement(ScrollView, {
    style: {
      maxHeight: scrollViewHeight
    }
  }, multiRadioGroupProps === null || multiRadioGroupProps === void 0 ? void 0 : multiRadioGroupProps.map(function (radioGroupProps) {
    return /*#__PURE__*/React.createElement(View, {
      key: radioGroupProps.options.toString(),
      style: {
        backgroundColor: '#F5F5F5'
      }
    }, /*#__PURE__*/React.createElement(RadioGroup, _extends({}, radioGroupProps, {
      containerStyle: _objectSpread({
        backgroundColor: 'white'
      }, radioGroupProps.groupStyle),
      options: radioGroupProps.options ? radioGroupProps.options.map(function (opt) {
        return _objectSpread(_objectSpread({}, opt), {}, {
          textStyle: _objectSpread({
            lineHeight: undefined
          }, opt.textStyle),
          containerStyle: _objectSpread(_objectSpread({}, styles['popup-option-radio']), opt.containerStyle)
        });
      }) : []
    })));
  })), ((_ref2 = multiCheckboxGroupProps || []) === null || _ref2 === void 0 ? void 0 : _ref2.length) > 0 && /*#__PURE__*/React.createElement(ScrollView, {
    style: {
      height: scrollViewHeight
    }
  }, multiCheckboxGroupProps === null || multiCheckboxGroupProps === void 0 ? void 0 : multiCheckboxGroupProps.map(function (checkboxGroupProps) {
    var _checkboxGroupProps$o;
    return ((_checkboxGroupProps$o = checkboxGroupProps.options) === null || _checkboxGroupProps$o === void 0 ? void 0 : _checkboxGroupProps$o.length) > 0 && /*#__PURE__*/React.createElement(View, {
      key: checkboxGroupProps.key
    }, (checkboxGroupProps === null || checkboxGroupProps === void 0 ? void 0 : checkboxGroupProps.groupTitle) && /*#__PURE__*/React.createElement(Text, {
      style: styles['popup-option-checkbox-group-title']
    }, checkboxGroupProps === null || checkboxGroupProps === void 0 ? void 0 : checkboxGroupProps.groupTitle), /*#__PURE__*/React.createElement(CheckboxGroup, _extends({}, checkboxGroupProps, {
      containerStyle: _objectSpread({
        backgroundColor: 'white'
      }, checkboxGroupProps.groupStyle),
      options: checkboxGroupProps.options ? checkboxGroupProps.options.map(function (opt) {
        return _objectSpread(_objectSpread({}, opt), {}, {
          textStyle: _objectSpread({
            lineHeight: undefined
          }, opt.textStyle),
          containerStyle: _objectSpread({}, opt.containerStyle)
        });
      }) : []
    })));
  }), endText && /*#__PURE__*/React.createElement(Text, {
    style: styles['popup-option-checkbox-group-end-text']
  }, endText)), /*#__PURE__*/React.createElement(Button, _extends({}, footerProps, {
    styles: _objectSpread({
      containerStyle: {
        marginTop: 0
      }
    }, footerProps.styles),
    type: "primary",
    onClick: onFooterClick
  })))), /*#__PURE__*/React.createElement(Modal, _extends({}, modalProps || {}, {
    active: modalActive,
    onClose: onModalClose,
    footer: modalFooter
  }), modalProps === null || modalProps === void 0 ? void 0 : modalProps.children));
};